import * as history from './history';
import loadScript, { unloadScript } from './load-script';
const inlineScriptsList = [];
// On each push-loaded & pop-loaded we go through the registered inline scripts and
// see which ones we should eval. If the HTMLElement toupled with the script exists
// in the dom, we have done a history change with lead to no DOM change on the noscript
// tag, but we should still run the script again, as this should mimic the behavior
// of a normal page load in browsers
history.onHistory(['push-loaded', 'pop-loaded'], () => {
    for (let i = 0; i < inlineScriptsList.length; i++) {
        // If this is the first time the event has fired for this script, it has already been
        // eval:ed when the HTMLElement mounted
        if (inlineScriptsList[i].firstRun) {
            inlineScriptsList[i].firstRun = false;
            return;
        }
        // Find out if the element in the touple exists in the DOM
        let elem = inlineScriptsList[i].domElement;
        let existsInDom = false;
        while (elem) {
            if (elem.parentElement === document.body) {
                existsInDom = true;
                break;
            }
            elem = elem.parentElement;
        }
        if (existsInDom) {
            try {
                console.info('Evaluating inline script', inlineScriptsList[i].script);
                if (inlineScriptsList[i].domElement.src) {
                    loadScript(inlineScriptsList[i].domElement.src);
                }
                else {
                    eval(inlineScriptsList[i].script);
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        else {
            inlineScriptsList.splice(i, 1);
        }
    }
});
export const addScript = (inlineScript) => {
    if (!__BROWSER__) {
        console.warn('addScript should not be used during server-side rendering');
        return;
    }
    if (__DEV__) {
        if (elementExists(inlineScript.domElement)) {
            throw new Error("Same inline script will be evaluated twice on next pop-/push-loaded event, don't insert the same element");
        }
    }
    inlineScriptsList.push(inlineScript);
};
export const removeScript = (inlineScript) => {
    if (!__BROWSER__) {
        console.warn('removeScript should not be used during server-side rendering');
        return;
    }
    inlineScriptsList.splice(inlineScriptsList.indexOf(inlineScript), 1);
    if (inlineScript.domElement.src) {
        unloadScript(inlineScript.domElement.src);
    }
};
export const elementExists = (element) => {
    return inlineScriptsList.filter(s => s.domElement === element).length > 0;
};
